import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {ActivatedRoute} from '@angular/router';
import {BehaviorSubject} from 'rxjs';
import {AuthService} from 'src/app/services/auth.service';
import {RequestApiService} from 'src/app/services/domain_code/request-api.service';

@Component({
    selector: 'logzy-cold-leads',
    templateUrl: './cold-leads.component.html',
    styleUrls: ['./cold-leads.component.scss']
})
export class ColdLeadsComponent implements OnInit {

    requestResponse: any;
    isCustomer: boolean;
    quoteHistoryList;
    quoteHistoryListData;

    @Output()
    forceRefresh = new BehaviorSubject(null);

    @Output()
    reqContainers = new EventEmitter();

    constructor(private route: ActivatedRoute,
        public requestService: RequestApiService,
        public authService: AuthService
    ) {
        this.forceRefresh.next(true)
    }

    ngOnInit(): void {
        this.isCustomer = this.authService.isCustomer();
        this.getPreviousQuotes();
        this.route.queryParams.subscribe(params => {
            if ('id' in params) {
                this.getDetailsByreqId(params['id']);

            }
        });
    }

    getDetailsByreqId(id) {
        this.requestService.getRequestDetailsById(id).subscribe({
            next: response => {
                this.requestResponse = response;
            },
        })
    }

    // GET quotes for requirements
    getPreviousQuotes() {
        this.requestService.getQuoteHistory(this.requestService.selectedRequest.id).subscribe({
            next: response => {
                this.quoteHistoryList = response.results[0];
                this.quoteHistoryListData = new MatTableDataSource(response.results);
                console.log("this.quoteHistoryList123", this.quoteHistoryList)
                return response;
            }
        })
    }

    showContainers(data: any) {
        this.reqContainers.emit(data);
    }
}
